export const handleOnChangeValueForm = <T extends object>(propState: string, value: any, currentState: T) => {
    if (!currentState.hasOwnProperty(propState)) {
        console.warn(`property ${propState} does not exist int the object.`)
      return currentState;
    }
  const newInfo: T = { ...currentState, [propState]: value };
  return newInfo;
};
